import { Box } from "@mui/material";
import { Suspense } from "react";
import { ForgotPW } from "@/features/auth";

export default function ForgotPasswordPage() {
	return (
		<Box
			sx={{
				marginTop: 8,
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				borderRadius: 1,
				padding: 2,
			}}
		>
			<Suspense fallback={<div>Loading...</div>}>
				<ForgotPW />
			</Suspense>
		</Box>
	);
}
